import {ScrollRestoration, useLoaderData, useParams} from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { getHomeInfo } from "../../server/getHomeInfo";
import useGetZone from "../../hooks/useGetZone";
import SlideShow from "./SlideShow/SlideShow";
import FeaturedExcursions from "./FeaturedExcursions/FeaturedExcursions";
import Experiences from "./Experiences/Experiences";
import ExcursionsGroup from "./ExcursionsGroup/ExcursionsGroup";
import AllExcursions from "./AllExcursions/AllExcursions";
import SEO from "components/SEO/SEO";

//CSS
import styles from "./home.module.less";

export async function loader({ params }) {

    const response = await getHomeInfo(params.language, params.zone);

    if(process.env.REACT_APP_DEBUG == 'true') console.log("[HOME] -> Loader");
    if(process.env.REACT_APP_DEBUG == 'true') console.log("response", response);

    if (!response.error){
        return response.data;
    }else{
        throw new Error("Loader getHomeInfo:", { cause: response.error })
    }
}

export default function Home () {
    const loadData = useLoaderData();
    const [t,i18n] = useTranslation("pages");
    const zone  = useGetZone();

    return (
      <>
        <SEO title={t('home.SEOTitulo')} description={t('home.SEODescipcion')} name='Viajes Teide' type='excursion' />

        <SlideShow slides={loadData.slides}/>

        <div className={styles.section}>
            <h2>{t('home.Las excursiones más populares')}</h2>
            <FeaturedExcursions excursions={loadData.homeExcursions} language={i18n.language} zone={zone} />
        </div>

        <div className={styles.section}>
            <Experiences />
        </div>

        <div className={styles.section}>
          <h2>{t('home.Las excursiones por grupos')}</h2>
          <ExcursionsGroup groups={loadData.excursionsgroups} language={i18n.language} zone={zone}/>
        </div>
          
        <div className={styles.section}>
            <h2>{t('home.Todas las excursiones')}</h2>
            <AllExcursions excursions={loadData.allExcursions} language={i18n.language} zone={zone}/>
        </div>

          <ScrollRestoration />
      </>
    )
}


